import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=7298037f&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7298037f')) {
      api.createRecord('7298037f', component.options)
    } else {
      api.reload('7298037f', component.options)
    }
    module.hot.accept("./Document.vue?vue&type=template&id=7298037f&", function () {
      api.rerender('7298037f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Document.vue"
export default component.exports